import { Navigate } from "react-router-dom";

import { RoutePathEnum } from "@/routes/paths";
import { useUserStore } from "@/stores/use-user-store";
import { getUserInitialDepartmentRoute } from "@/utils/department-routes";

/**
 * Redireciona a raiz (/) para a página de talentos do department do usuário.
 * Se o usuário não está autenticado, redireciona para login.
 */
export function RootRedirect() {
  const { activeUser, isLoading } = useUserStore();

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="h-12 w-12 animate-spin rounded-full border-b-2 border-primary"></div>
      </div>
    );
  }

  // Se não há usuário autenticado, redirecionar para login
  if (!activeUser) {
    return <Navigate to={RoutePathEnum.LOGIN} replace />;
  }

  const initialDepartmentRoute = getUserInitialDepartmentRoute(activeUser);

  if (!initialDepartmentRoute) {
    return <Navigate to={RoutePathEnum.LOGIN} replace />;
  }

  return <Navigate to={initialDepartmentRoute} replace />;
}
